const features = {
  apple_podcasts_subscription: {
    key: 'apple_podcasts_subscription'
  },
  unlimited_podcasts: {
    key: 'unlimited_podcasts',
    unlimited: true
  },
  unlimited_episodes: {
    key: 'unlimited_episodes',
    unlimited: true
  },
  unlimited_duration: {
    key: 'unlimited_duration',
    unlimited: true
  },
  analytics: {
    key: 'analytics'
  },
  feed: {
    key: 'feed'
  },
  website: {
    key: 'website'
  },
  audio_to_video: {
    key: 'audio_to_video'
  },
  episode_transcripts: {
    key: 'episode_transcripts'
  },
  free_website: {
    key: 'free_website'
  },
  embedded_player: {
    key: 'embedded_player'
  },
  scheduling: {
    key: 'scheduling'
  },
  monetize: {
    key: 'monetize'
  },
  auto_submission: {
    key: 'auto_submission',
    tooltip: true
  },
  auto_distribution: {
    key: 'auto_distribution',
    tooltip: true
  },
  media_sharing: {
    key: 'media_sharing'
  },
  multiple_podcasts: {
    key: 'multiple_podcasts',
    tooltip: true
  },
  dynamic_ads: {
    key: 'dynamic_ads',
    tooltip: true
  },
  custom_analytics: {
    key: 'custom_analytics',
    tooltip: true
  },
  special_requests: {
    key: 'special_requests'
  },
  support: {
    key: 'support'
  },
  pro_support: {
    key: 'pro_support'
  },
  enterprise_support: {
    key: 'enterprise_support',
    tooltip: true
  }
}

export default features
